import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CTASection from '../components/CTASection';
import { Card } from '../components/ui/card';
import { FileText, Shield, Cookie, AlertTriangle, ArrowRight } from 'lucide-react';
import { legalDocuments } from '../data/legalData';

/**
 * Icon mapping for legal documents
 */
const iconMap = {
  FileText,
  Shield,
  Cookie,
  AlertTriangle
};

const LegalPage = () => {
  return (
    <div className="min-h-screen" data-testid="legal-page">
      <Header />
      
      <section className="py-16 md:py-20">
        <div className="container mx-auto px-6 md:px-12 lg:px-24 xl:px-32">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-heading font-bold mb-4">
              Legal
            </h1>
            <p className="text-lg text-[rgb(var(--foreground-muted))] max-w-2xl mx-auto">
              These documents explain how Flippex works and how we handle your data.
            </p>
          </div>

          {/* Legal Document Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            {legalDocuments.map((doc) => {
              const Icon = iconMap[doc.icon] || FileText;
              
              return (
                <Link key={doc.id} to={doc.path}>
                  <Card className="glass p-6 h-full hover:border-[rgb(var(--primary))]/30 hover:-translate-y-1 transition-all duration-300 group">
                    <div className="flex items-start gap-4">
                      <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-[rgb(var(--primary))]/10 flex items-center justify-center group-hover:bg-[rgb(var(--primary))]/20 transition-colors">
                        <Icon className="w-6 h-6 text-[rgb(var(--primary))]" />
                      </div>
                      <div className="flex-1">
                        <h2 className="text-lg font-heading font-semibold mb-2 group-hover:text-[rgb(var(--primary))] transition-colors flex items-center">
                          {doc.title}
                          <ArrowRight className="w-4 h-4 ml-2 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                        </h2>
                        <p className="text-sm text-[rgb(var(--foreground-muted))]">
                          {doc.description}
                        </p>
                      </div>
                    </div>
                  </Card>
                </Link>
              );
            })}
          </div>

          {/* Disclaimer */}
          <div className="mt-12 text-center">
            <p className="text-sm text-[rgb(var(--foreground-muted))]/60 max-w-2xl mx-auto">
              These documents are provided for informational purposes. For specific legal questions, 
              please consult with qualified legal counsel or contact us at{' '}
              <a href="mailto:legal@flippex.com" className="text-[rgb(var(--primary))] hover:underline">
                legal@flippex.com
              </a>
            </p>
          </div>
        </div>
      </section>

      <CTASection />

      <Footer />
    </div>
  );
};

export default LegalPage;
